module.exports = __webpack_public_path__ + "img/hohlschnitt_reinorange_ral2004.6701dfbc.jpg";